<script>
import deepLink from '@/mixins/deeplink.js'

export default {
  name: 'DeepLinkButton',
  mixins: [deepLink()],
  props: {
    componentData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  },
  computed: {
    getText() {
      return this.componentData.text || ''
    },
    getDeepLink() {
      return this.componentData.deepLink || ''
    }
  },
  methods: {
    callDeepLink() {
      this.callGenericDeeplink(this.getDeepLink)
    }
  }
}
</script>

<template>
  <section
    :class="$style.container"
    @click="callDeepLink">
    <h4>{{ getText }}</h4>
  </section>
</template>

<style lang="scss" scoped module>
@import '@design';

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;

  h4 {
    cursor: pointer;
    color: $color-button-bg;
  }
}

</style>
